import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRemoveProjectPortfolioRequestFailure(portfolio) {
      const req = getState().find(
        (req) => req.portfolio.uuid === portfolio.uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isRemoveProjectPortfolioRequestPending(portfolio) {
      const req = getState().find(
        (req) => req.portfolio.uuid === portfolio.uuid,
      );

      return req ? req.request.isPending : false;
    },
    isRemoveProjectPortfolioRequestSuccess(portfolio) {
      const req = getState().find(
        (req) => req.portfolio.uuid === portfolio.uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
